if(typeof require !== 'undefined'){
  var d3 = require('d3');
}

const SIGNHEIGHT = '20';
const SIGNWIDTH = '40';
const BORDERRADIUS = '2';
const LOWSIGNOFFSET = -(SIGNHEIGHT * 1.5);
const HIGHSIGNOFFSET = -(SIGNHEIGHT * 2.65);

class TimelineEventSignPost{

  constructor(parent){
    this.parent = parent;
  }

  render(){
    this._container();
    this._line();
    this._sign();
  }

  _container(){
    this.container = this.parent
      .filter(d => { return d.signPost ? true : false; })
      .append('g')
      .classed('timeline-sign-post', true)
      .classed('timeline-sign-post--important', (d) => d.important ? true : false);
  }

  _line(){
    this.container.append('line')
      .attr('x1', 0)
      .attr('y1', 0)
      .attr('x1', 0)
      .attr('y1', (event) => {
        return event.important ? HIGHSIGNOFFSET : LOWSIGNOFFSET;
      });
  }

  _sign(){
    this._signContainer();
    this._signBackground();
    this._signText();
  }

  _signContainer(){
    this.signContainer = this.container.append('g')
      .classed('timeline-sign', true)
      .attr('transform', 'translate(0,0)')
      .attr('transform', (event) => {
        const offset = event.important ? HIGHSIGNOFFSET : LOWSIGNOFFSET;
        return `translate(0,${offset})`;
      });
  }

  _signBackground(){
    this.signContainer.append('rect')
      .attr('height', SIGNHEIGHT)
      .attr('y', -(SIGNHEIGHT/2))
      .attr('width', SIGNWIDTH)
      .attr('x', -(SIGNWIDTH/2))
      .attr('rx', BORDERRADIUS)
      .attr('ry', BORDERRADIUS);
  }

  _signText(){
    this.signContainer.append('text')
      .text(d => d.signPost)
      .attr('text-anchor', 'middle')
      .attr('alignment-baseline', 'middle');
  }

}



if(typeof module !== 'undefined' && module.exports){
  module.exports = TimelineEventSignPost;
}else if(typeof window !== 'undefined'){
  window.TimelineSignPost = TimelineEventSignPost;
}
